import { render, staticRenderFns } from "./back-arrow.vue?vue&type=template&id=441419f2&scoped=true"
import script from "./back-arrow.vue?vue&type=script&lang=js"
export * from "./back-arrow.vue?vue&type=script&lang=js"
import style0 from "./back-arrow.vue?vue&type=style&index=0&id=441419f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441419f2",
  null
  
)

export default component.exports